import axios from "axios";
import { TTP_API_URL } from "Config";

export const getBlogCategories = ({ token, lng }) => {
  const requestUrl = `${TTP_API_URL}/blog/category`;

  const filter = [{ property: "language", value: lng, operator: "like" }];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      nolimit: 1
    }
  });
};

export const getBlogTypes = ({ token, communityId, lng = "fr" }) => {
  const requestUrl = `${TTP_API_URL}/blog/type`;

  const filter = [
    { property: "language", value: lng, operator: "eq" },
    { property: "organization", value: communityId, operator: "inWithNull" }
  ];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter)
    }
  });
};

export const getBlogThemes = ({ token, communityId, lng }) => {
  const requestUrl = `${TTP_API_URL}/blog/theme`;

  const filter = [
    { property: "isDefault", value: 0, operator: "eq" },
    { property: "language", value: lng, operator: "eq" },
    { property: "organization", value: communityId, operator: "eq" }
  ];
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter)
    }
  });
};

export const getMediaCategories = ({ token, limit }) => {
  const requestUrl = `${TTP_API_URL}/media/category`;

  const filter = [{ property: "type", value: "MEDIA", operator: "like" }];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      limit
    }
  });
};

export const getGroups = ({ token, clientId = null, customFilter = null }) => {
  const requestUrl = `${TTP_API_URL}/mailing/group`;
  let filter = [
    {
      property: "client.id",
      value: clientId,
      operator: "eq"
    }
  ];

  if (customFilter !== null && Array.isArray(customFilter)) {
    filter.push(...customFilter);
  }

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      nolimit: 1,
      fields: "id, name",
      filter: JSON.stringify(filter)
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/filter.js